<template>
  <div>
    <el-dialog
      class="views-bulletin-components-device-connect-list"
      width="50%"
      title="連線管理"
      :visible.sync="isDialogVisible"
      destroy-on-close
    >
      <el-table
        :data="deviceConnectList"
        class="views-bulletin-components-device-connect-list__table"
      >
        <el-table-column
          label="#"
          type="index"
          width="50"
        />
        <el-table-column
          prop="Name"
          label="裝置名稱"
          show-overflow-tooltip
        />
        <el-table-column
          prop="Status"
          label="連線狀態"
          width="100"
        >
          <template slot-scope="scope">
            <div
              :class="[
                scope.row.IsHealthy ? 'views-bulletin-components-device-connect-list__table-status--connected' : 'views-bulletin-components-device-connect-list__table-status--unconnected'
              ]"
            >
              {{ scope.row.IsHealthy ? '連線中' : '斷線中' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="LastHealthyAt"
          label="最後連線時間"
          width="150"
          :formatter="dateFormat"
        />
        <el-table-column
          label="操作"
          width="90"
        >
          <template slot-scope="scope">
            <template>
              <el-button
                type="danger"
                size="mini"
                :disabled="isSubmitting"
                plain
                @click="deleteDeviceConnect(scope.row.Id)"
              >
                解除
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: () => ({})
    },
    list: {
      type: Array,
      default: () => []
    },
    boardId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isSubmitting: false,
      deviceConnectList: []
    }
  },
  computed: {
    isDialogVisible: {
      get () {
        return this.isVisible
      },
      set (value) {
        this.$emit('update:isVisible', value)
      }
    }
  },
  watch: {
    list (newValue, oldValue) {
      console.log('watch newValue', newValue)
      this.deviceConnectList = newValue
    }
  },
  methods: {
    dateFormat (data) {
      if (data.LastHealthyAt) return dayjs(data.LastHealthyAt).format('YYYY-MM-DD HH:mm')
    },
    async getDeviceConnectList () {
      try {
        const boardId = { boardID: this.boardId }
        const { data } = await apiBulletin.getDisplayDeviceList(boardId)
        console.log('getDeviceConnectList boardId', this.boardId)
        console.log('getDeviceConnectList data', data)
        this.deviceConnectList = data
      } catch (error) {
        console.log('error', error)
        this.$message.error('伺服器發生錯誤')
      }
    },
    deleteDeviceConnect (id) {
      this.isSubmitting = true
      this.$confirm('連線裝置解除後將無法復原，確認是否解除？', '', { confirmButtonText: '確定', cancelButtonText: '取消' })
        .then(async () => {
          try {
            console.log('deleteDeviceConnect this.boardId', this.boardId)
            console.log('deleteDeviceConnect displayDeviceID', id)
            const queryPath = { id: this.boardId, displayDeviceID: id }
            await apiBulletin.deleteDisplayDevice(queryPath)
            this.$message.success('解除成功')
            this.getDeviceConnectList()
            this.$emit('update')
          } catch (error) {
            this.$message.error('伺服器發生錯誤')
            console.log('error', error)
          } finally {
            this.isSubmitting = false
          }
        })
        .catch(() => { this.isSubmitting = false })
    }
  }
}
</script>

<style lang="sass">
.views-bulletin-components-device-connect-list .el-dialog
  border-radius: $pageBorderRadius
  &__header
    border-top-left-radius: $pageBorderRadius
    border-top-right-radius: $pageBorderRadius
    background-color: $bgDark3
  &__title
    color: $mainFontColor
    font-size: map-get($fontSize,large)
    font-weight: bold
    line-height: 32px
  &__close
    font-size: 25px
    font-weight: bolder
    color: $subFontColor
  &__body
    display: flex
    flex-direction: column
    font-size: map-get($fontSize,small)
    padding: 35px 40px

.views-bulletin-components-device-connect-list__table .el-table
  +basicTable

.views-bulletin-components-device-connect-list__table-status--connected
  color: $mainColor

.views-bulletin-components-device-connect-list__table-status--unconnected
  color: $dangerColor
</style>
